import type {SVGProps} from 'react'
import * as React from 'react'
const NoMessageIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="121" height="120" fill="none" viewBox="0 0 121 120" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M120.5 100.69C120.5 84.4069 93.6371 71.207 60.5 71.207C27.3629 71.207 0.5 84.4069 0.5 100.69C0.5 116.973 120.5 116.973 120.5 100.69Z"
      fill="url(#paint0_linear_17513_7134)"
    />
    <g opacity="0.8">
      <g opacity="0.8">
        <path opacity="0.8" d="M15.5 83.3191V89.7846" stroke="#AECFFF" strokeWidth="2.66667" strokeLinecap="round" />
        <path
          opacity="0.8"
          d="M15.3268 70.345C11.4058 74.4614 9.7149 77.5919 10.254 79.7367C11.0626 82.9539 14.2807 83.4484 15.0761 83.4484C15.8715 83.4484 20.5011 83.5095 20.5011 79.2214C20.5011 76.3627 18.7763 73.4039 15.3268 70.345Z"
          fill="#D7E7FF"
        />
      </g>
      <g opacity="0.8">
        <path opacity="0.8" d="M101.707 81.8752V86.4011" stroke="#AECFFF" strokeWidth="2.66667" strokeLinecap="round" />
        <path
          opacity="0.8"
          d="M101.705 72.7588C98.9606 75.6836 97.777 77.9079 98.1544 79.4319C98.7204 81.7177 100.973 82.0691 101.53 82.0691C102.087 82.0691 105.327 82.1125 105.327 79.0657C105.327 77.0346 104.12 74.9322 101.705 72.7588Z"
          fill="#D7E7FF"
        />
      </g>
      <g opacity="0.8">
        <path opacity="0.8" d="M112.742 88.0496V91.6056" stroke="#AECFFF" strokeWidth="2.66667" strokeLinecap="round" />
        <path
          opacity="0.8"
          d="M112.914 81.3794C110.823 83.5459 109.921 85.1936 110.208 86.3224C110.64 88.0157 112.356 88.276 112.78 88.276C113.204 88.276 115.673 88.3081 115.673 86.0512C115.673 84.5466 114.754 82.9894 112.914 81.3794Z"
          fill="#D7E7FF"
        />
      </g>
    </g>
    <g filter="url(#filter0_f_17513_7134)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.7773 81.1018H54.2309L61.1363 87.8223L58.7225 87.7034L46.7773 81.1018Z"
        fill="url(#paint1_linear_17513_7134)"
      />
    </g>
    <path fillRule="evenodd" clipRule="evenodd" d="M58.9023 85.8672H60.5009V88.1274H58.9023V85.8672Z" fill="#8BBAFD" />
    <path
      d="M58.4219 34.5542C73.2538 34.5542 85.2774 45.0033 85.2774 57.8929C85.2774 68.7337 76.7724 77.8481 65.2447 80.4718L59.6626 87.7519C59.6115 87.8187 59.5518 87.8784 59.485 87.9295C59.0647 88.2518 58.4626 88.1723 58.1403 87.7519L52.7399 80.7082C40.637 78.4426 31.5664 69.0883 31.5664 57.8929C31.5664 45.0033 43.59 34.5542 58.4219 34.5542Z"
      fill="url(#paint2_linear_17513_7134)"
    />
    <path
      d="M60.6602 34.5542C75.4921 34.5542 87.5157 45.0033 87.5157 57.8929C87.5157 68.9722 78.6323 78.2484 66.7178 80.6355L61.2615 87.7519C61.2103 87.8187 61.1506 87.8784 61.0839 87.9295C60.6635 88.2518 60.0615 88.1723 59.7392 87.7519L54.2231 80.5569C42.4999 78.0507 33.8047 68.8543 33.8047 57.8929C33.8047 45.0033 45.8283 34.5542 60.6602 34.5542Z"
      fill="url(#paint3_linear_17513_7134)"
    />
    <path
      d="M60.8236 60.9299C63.2955 60.9299 65.2995 58.9259 65.2995 56.4539C65.2995 53.982 63.2955 51.978 60.8236 51.978C58.3516 51.978 56.3477 53.982 56.3477 56.4539C56.3477 58.9259 58.3516 60.9299 60.8236 60.9299Z"
      fill="url(#paint4_linear_17513_7134)"
    />
    <path
      d="M49.3119 60.9299C51.7838 60.9299 53.7878 58.9259 53.7878 56.4539C53.7878 53.982 51.7838 51.978 49.3119 51.978C46.8399 51.978 44.8359 53.982 44.8359 56.4539C44.8359 58.9259 46.8399 60.9299 49.3119 60.9299Z"
      fill="url(#paint5_linear_17513_7134)"
    />
    <path
      d="M72.3314 60.9299C74.8034 60.9299 76.8073 58.9259 76.8073 56.4539C76.8073 53.982 74.8034 51.978 72.3314 51.978C69.8594 51.978 67.8555 53.982 67.8555 56.4539C67.8555 58.9259 69.8594 60.9299 72.3314 60.9299Z"
      fill="url(#paint6_linear_17513_7134)"
    />
    <path
      d="M60.1842 60.4503C62.303 60.4503 64.0207 58.7327 64.0207 56.6138C64.0207 54.495 62.303 52.7773 60.1842 52.7773C58.0653 52.7773 56.3477 54.495 56.3477 56.6138C56.3477 58.7327 58.0653 60.4503 60.1842 60.4503Z"
      fill="white"
    />
    <path
      d="M48.6724 60.4503C50.7913 60.4503 52.5089 58.7327 52.5089 56.6138C52.5089 54.495 50.7913 52.7773 48.6724 52.7773C46.5536 52.7773 44.8359 54.495 44.8359 56.6138C44.8359 58.7327 46.5536 60.4503 48.6724 60.4503Z"
      fill="white"
    />
    <path
      d="M71.692 60.4503C73.8108 60.4503 75.5285 58.7327 75.5285 56.6138C75.5285 54.495 73.8108 52.7773 71.692 52.7773C69.5731 52.7773 67.8555 54.495 67.8555 56.6138C67.8555 58.7327 69.5731 60.4503 71.692 60.4503Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_f_17513_7134"
        x="45.444"
        y="79.7685"
        width="17.026"
        height="9.38713"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="0.666667" result="effect1_foregroundBlur_17513_7134" />
      </filter>
      <linearGradient
        id="paint0_linear_17513_7134"
        x1="60.5"
        y1="71.207"
        x2="60.5"
        y2="109.62"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E0EDFF" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_17513_7134"
        x1="56.479"
        y1="84.2839"
        x2="56.708"
        y2="85"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#418EFF" stopOpacity="0" />
        <stop offset="1" stopColor="#418EFF" stopOpacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_17513_7134"
        x1="58.4219"
        y1="88.1276"
        x2="58.4219"
        y2="34.5542"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.000184755" stopColor="#8AB9FD" />
        <stop offset="1" stopColor="#DFECFF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_17513_7134"
        x1="60.6602"
        y1="83.3981"
        x2="60.6602"
        y2="38.9281"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C4DCFF" />
        <stop offset="1" stopColor="#EFF6FF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_17513_7134"
        x1="60.8236"
        y1="60.9299"
        x2="60.8236"
        y2="51.978"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.000184755" stopColor="#8AB9FD" />
        <stop offset="1" stopColor="#DFECFF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_17513_7134"
        x1="49.3119"
        y1="60.9299"
        x2="49.3119"
        y2="51.978"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.000184755" stopColor="#8AB9FD" />
        <stop offset="1" stopColor="#DFECFF" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_17513_7134"
        x1="72.3314"
        y1="60.9299"
        x2="72.3314"
        y2="51.978"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.000184755" stopColor="#8AB9FD" />
        <stop offset="1" stopColor="#DFECFF" />
      </linearGradient>
    </defs>
  </svg>
)
export default NoMessageIcon
